function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import html2pdf from 'html2pdf.js';
import Loader from 'react-loader-advanced';

/**
 * @memberOf module:wdh-feature-b2b
 */
var _SboPrintModalDialog = function SboPrintModalDialog(props) {
  var blurElementID = props.blurElementID,
    blurBackground = props.blurBackground,
    isOpen = props.isOpen,
    type = props.type,
    showCloseButton = props.showCloseButton,
    onRequestClose = props.onRequestClose,
    downloadButtonCallback = props.downloadButtonCallback,
    downloadID = props.downloadID,
    downloadLabel = props.downloadLabel,
    printButtonCallback = props.printButtonCallback,
    printID = props.printID,
    printLabel = props.printLabel,
    showButtonIcons = props.showButtonIcons,
    children = props.children,
    defaultFilename = props.defaultFilename;
  var wrapper = document.getElementById(blurElementID);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSpinner = _useState2[0],
    setShowSpinner = _useState2[1];
  useEffect(function () {
    if (wrapper) {
      if (isOpen && blurBackground) {
        wrapper.style.filter = 'blur(3px)';
      } else {
        wrapper.style.filter = '';
      }
    }
    return function () {
      if (wrapper && isOpen) {
        wrapper.style.filter = '';
      }
    };
  }, [isOpen]);
  var downloadPDF = function downloadPDF(event, id) {
    var elem = document.getElementById(id);
    document.querySelector('html').classList.add('is-printing');
    html2pdf().set({
      filename: defaultFilename,
      image: {
        type: 'jpeg'
      },
      html2canvas: {
        scale: 4
      },
      jsPDF: {
        unit: 'in',
        format: 'letter',
        orientation: 'portrait'
      },
      pagebreak: {
        avoid: '.order-line',
        before: '.supporting-images-section'
      }
    }).from(elem).save().then(function () {
      setShowSpinner(false);
      downloadButtonCallback(event);
      document.querySelector('html').classList.remove('is-printing');
    });
  };
  var printOrder = function printOrder(event, id) {
    var printNode = document.getElementById(id);
    var domClone = printNode.cloneNode(true);
    var printSection = document.getElementById('print-section');
    if (!printSection) {
      printSection = document.createElement('div');
      printSection.id = 'print-section';
      document.body.appendChild(printSection);
    }
    printSection.innerHTML = '';
    printSection.appendChild(domClone);
    document.body.classList.add('is-printing');
    window.print();
    setShowSpinner(false);
    printButtonCallback(event);
  };
  var renderTemplate = function renderTemplate() {
    var id = uuid();
    return /*#__PURE__*/React.createElement("div", {
      className: "modal"
    }, /*#__PURE__*/React.createElement(Loader, {
      show: showSpinner
    }, /*#__PURE__*/React.createElement("div", {
      className: "content",
      id: id
    }, showCloseButton && /*#__PURE__*/React.createElement("span", {
      className: "close",
      role: "button",
      tabIndex: "0",
      onClick: function onClick(event) {
        return onRequestClose(event);
      }
    }), children)), /*#__PURE__*/React.createElement("div", {
      className: "buttons"
    }, (type === _SboPrintModalDialog.types.printDownload || type === _SboPrintModalDialog.types.downloadOnly) && /*#__PURE__*/React.createElement("button", {
      id: downloadID,
      className: "wdh-feature-b2b-button popup-btn ".concat(showButtonIcons && 'download-btn'),
      type: "button",
      onClick: function onClick(event) {
        setShowSpinner(true);
        downloadPDF(event, id);
      }
    }, downloadLabel), (type === _SboPrintModalDialog.types.printDownload || type === _SboPrintModalDialog.types.printOnly) && /*#__PURE__*/React.createElement("button", {
      id: printID,
      className: "wdh-feature-b2b-button popup-btn",
      type: "button",
      onClick: function onClick(event) {
        setShowSpinner(true);
        printOrder(event, id);
      }
    }, printLabel)));
  };
  return /*#__PURE__*/React.createElement(Modal
  // eslint-disable-next-line react/jsx-props-no-spreading
  , props, renderTemplate());
};
var types = {
  printDownload: 'printDownload',
  printOnly: 'printOnly',
  downloadOnly: 'downloadOnly'
};
_SboPrintModalDialog.types = types;
_SboPrintModalDialog.propTypes = {
  // types for those existing props that have default values
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  overlayClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    base: PropTypes.string.isRequired,
    afterOpen: PropTypes.string.isRequired,
    beforeClose: PropTypes.string.isRequired
  })]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    base: PropTypes.string.isRequired,
    afterOpen: PropTypes.string.isRequired,
    beforeClose: PropTypes.string.isRequired
  })]),
  style: PropTypes.shape({
    content: PropTypes.object,
    overlay: PropTypes.object
  }),
  ariaHideApp: PropTypes.bool,
  // added props
  type: PropTypes.oneOf(Object.keys(types)),
  downloadButtonCallback: PropTypes.func,
  printLabel: PropTypes.string,
  printID: PropTypes.string,
  printButtonCallback: PropTypes.func,
  downloadLabel: PropTypes.string,
  downloadID: PropTypes.string,
  showButtonIcons: PropTypes.bool,
  blurBackground: PropTypes.bool,
  blurElementID: PropTypes.string,
  showCloseButton: PropTypes.bool,
  defaultFilename: PropTypes.string,
  shouldCloseOnOverlayClick: PropTypes.bool,
  shouldCloseOnEsc: PropTypes.bool,
  onRequestClose: PropTypes.func // needed for onClickOverlayClose and closeOnEsc and closeButton
};
_SboPrintModalDialog.defaultProps = {
  // default values for existing props
  overlayClassName: 'wdh-feature-btb-modalOverlay',
  className: 'wdh-feature-b2b-modalContent-print',
  style: {
    content: {}
  },
  ariaHideApp: false,
  // default values for added props
  downloadButtonCallback: function downloadButtonCallback() {},
  printLabel: 'Print',
  printID: 'modal-dialog-print',
  printButtonCallback: function printButtonCallback() {},
  downloadLabel: 'Download',
  downloadID: 'modal-dialog-download',
  showButtonIcons: true,
  type: _SboPrintModalDialog.types.blank,
  blurBackground: true,
  blurElementID: 'wrapper',
  showCloseButton: false,
  defaultFilename: 'Shipping Label',
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
  onRequestClose: function onRequestClose() {} // needed for onClickOverlayClose and closeOnEsc
};
export default _SboPrintModalDialog;